/* 
Object:         Group configuration
Description:    Logic and events for the module Group Configuration 
Used in:        Group configuration
*/

import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum"

import * as appsettings from "../appsettings"
import * as dialog      from "../dialog"
import * as form        from "../form";
import * as listbox     from "../listbox"
import * as main        from "../main"
import * as navigation  from "../navigation"
import * as viewmode    from "../viewmode"
import * as grid        from "../grid"

var _msg_notsaved = "";

var LABEL_YES = "";
var LABEL_NO = "";
var LABEL_DELETE = "";

var MIN_OCCUPANCY_HIGH = "";
var MIN_OCCUPANCY_LOW = "";

/**
* Delete group
* @param {number} groupId
*/
function deleteGroup(groupId: number): void {

    $.ajax({
        type: "GET",
        url: appsettings.getUrl("Group/DeleteGroup?groupId=" + groupId),
        success: function (responseData) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            navigation.navigateToSpecificUrl("Group/Overview");
        }
    });
}


/**
* Update Item from the grid.
* @param {JQuery.Event & { currentTarget: HTMLElement }} e
*/
export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // dataItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as GroupGridVM;

    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Group/Edit_Tabstrip?groupId=" + dataItem.GroupID + "&breadcrumbLabel=" + encodeURIComponent(dataItem.Label));
}

/**
* Show Item from the grid
* @param {JQuery.Event & { currentTarget: HTMLElement }} e
*/
export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // dataItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as GroupGridVM;

    // Show mode form 
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Group/Show_Tabstrip?groupId=" + dataItem.GroupID + "&breadcrumbLabel=" + encodeURIComponent(dataItem.Label));
}

/**
* Delete Item from the grid
* @param {JQuery.Event & { currentTarget: HTMLElement }} e
*/
export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid) {
        // Prevent default behaviour
        event.preventDefault();
        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as GroupGridVM;
        deleteGroup(dataItem.GroupID);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}


/**
* Validation Form 
*/
export function onFormValidateField(): void { }

/**
* Submit Form 
* @param {} e
*/
export function onFormSubmit(e: kendo.data.DataSourceEvent & { model: GroupGeneralVM }): void {

    e.model.TimeCalculation = $("#TimeCalculation").data("kendoTimePicker").value();                                //   element[0].value;
    e.model.SchedulerInfoSuppressFrom = $("#SchedulerInfoSuppressFrom").data("kendoTimePicker").value();
    e.model.SchedulerInfoSuppressTo = $("#SchedulerInfoSuppressTo").data("kendoTimePicker").value();
    e.model.TestAlarmMoment = $("#TestAlarmMoment").data("kendoTimePicker").value();

    if (e.model.OccupancyInfo) {
        e.model.Group1 = Number($("#Group1").data("kendoDropDownList").value());
        e.model.Group2 = Number($("#Group2").data("kendoDropDownList").value());
    }

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl(e.model.FormAction),
        data: e.model,
        success: function (responseData: responseModel | undefined | null) {
            form.showServerResponse("", responseData, function () { });
        }
    });
}

/**
* Field Understaffed at night changed. Set some fields hidden accordingly
* @param {kendo.ui.CheckBoxChangeEvent} e
*/
export function underStaffedNotAtNightChanged(e: kendo.ui.CheckBoxChangeEvent): void {
    main.setHideKendoUIFormItem4("SchedulerInfoSuppressFrom", e.checked);
    main.setHideKendoUIFormItem4("SchedulerInfoSuppressTo", e.checked);
}

/**
* Field OccupancyInfo is changed. Set some fields hidden accordingly
* @param {kendo.ui.CheckBoxChangeEvent} e
*/
export function occupancyInfoChanged(e: kendo.ui.CheckBoxChangeEvent): void {
    main.setHideKendoUIFormItem4("Group1", e.checked);
    main.setHideKendoUIFormItem4("Group2", e.checked);
}

/**
* Field UseConcanated is changed. Set some fields hidden accordingly
* @param {kendo.ui.CheckBoxChangeEvent} e
*/
export function useConcatenatedChanged(e: kendo.ui.CheckBoxChangeEvent): void {
    main.setHideKendoUIFormItem4("ConcatenatedMessageTime", e.checked);
    main.setHideKendoUIFormItem5("LUnitConcatenatedMessageTime", e.checked);
}

export function combinedGroupChanged(e: kendo.ui.CheckBoxChangeEvent): void {
    main.setHideKendoUIFormItem4("CombinedGroupTime", e.checked);
    main.setHideKendoUIFormItem5("LUnitCombinedGroupTime", e.checked);
}

/**
* Field TestAlarmDay is changed. Set some fields hidden accordingly
* @param {kendo.ui.DropDownListChangeEvent} e
*/
export function testAlarmDayChanged(e: kendo.ui.DropDownListChangeEvent): void {
    main.setHideKendoUIFormItem4("TestAlarmMoment", e.sender.value() !== '0');
    main.setHideKendoUIFormItem4("TestAlarmText", e.sender.value() !== '0');
}

/**
* Visibility Tab General 
*/
export function visibility_Tab_General(): void {

    const cb_oi = $("#OccupancyInfo").data("kendoCheckBox");
    if (cb_oi != null && cb_oi != undefined) {
        main.setHideKendoUIFormItem4("Group1", cb_oi.options.checked);
        main.setHideKendoUIFormItem4("Group2", cb_oi.options.checked);
    }

    const cb_ucm = $("#UseConcatenatedMessage").data("kendoCheckBox");
    if (cb_ucm != null && cb_ucm != undefined) {
        main.setHideKendoUIFormItem4("ConcatenatedMessageTime", cb_ucm.options.checked);
        main.setHideKendoUIFormItem5("LUnitConcatenatedMessageTime", cb_ucm.options.checked);
    }

    const cb_cg = $("#CombinedGroup").data("kendoCheckBox");
    if (cb_cg != null && cb_cg != undefined) {
        main.setHideKendoUIFormItem4("CombinedGroupTime", cb_cg.options.checked);
        main.setHideKendoUIFormItem5("LUnitCombinedGroupTime", cb_cg.options.checked);
    }

    const cb_sis = $("#SchedulerInfoSuppress").data("kendoCheckBox");
    if (cb_sis != null && cb_sis != undefined) {
        main.setHideKendoUIFormItem4("SchedulerInfoSuppressFrom", cb_sis.options.checked);
        main.setHideKendoUIFormItem4("SchedulerInfoSuppressTo", cb_sis.options.checked);
    }

    const cbb = $("#TestAlarmDay").data("kendoDropDownList");
    if (cbb != null && cbb != undefined) {
        main.setHideKendoUIFormItem4("TestAlarmMoment", cbb.value() !== '0');
        main.setHideKendoUIFormItem4("TestAlarmText", cbb.value() !== '0');
    }
}

//--- TAB Users --------------------------------------------------------------------------------------------------------------//

/**
* Init tab users
*/
export function tabUsersInitialize(notsaved: string): void {
    _msg_notsaved = notsaved;

    $("#notSelectedSearchBox").on("input", function () {
        const listBox = $("#GroupConfiguration_UserOccupancy_CplNotSelected").data("kendoListBox");
        const searchString = $(this).val();

        listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
    });

    $("#selectedSearchBox").on("input", function () {
        const listBox = $("#GroupConfiguration_UserOccupancy_CplSelected").data("kendoListBox");
        const searchString = $(this).val();

        listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
    });
}

/**
* Return label changed not saved
*/
export function tabUsersGetDataChangedNotSavedYet(): string {
    return _msg_notsaved;
}

/**
* Move user to the left
*/
export function tabUsersLeftClicked(): void {
    tabUsersEnableSaveButton();
    listbox.moveItems("GroupConfiguration_UserOccupancy_CplSelected", "GroupConfiguration_UserOccupancy_CplNotSelected", "#Users_Validation", tabUsersGetDataChangedNotSavedYet())
}

/**
* Move user to the right
*/
export function tabUsersRightClicked(): void {
    tabUsersEnableSaveButton();
    listbox.moveItems("GroupConfiguration_UserOccupancy_CplNotSelected", "GroupConfiguration_UserOccupancy_CplSelected", "#Users_Validation", tabUsersGetDataChangedNotSavedYet())
}

/**
* Enable save button
*/
export function tabUsersEnableSaveButton(): void {
    const btnSave = document.getElementById("saveButtonUsers");
    btnSave.removeAttribute("disabled");
}

/**
* Save button clicked
*/
export function tabUsersSaveButtonClicked(actionUrl: string, groupId: number): void {

    const listBox = $("#GroupConfiguration_UserOccupancy_CplSelected").data("kendoListBox");
    listBox.dataSource.filter({ field: "Text", operator: "contains", value: "" });

    const json = listBox.dataSource.view().toJSON();
    const list = json.slice();

    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        data: { list: kendo.stringify(list), groupId: groupId },
        success: function (responseData) {

            $('#Users_Validation').text("");

            $("#TableOccupancyLR").load(appsettings.getUrl("Group/GetOccupancyLR?groupId=" + groupId));

            $("#TableOccupancyInfo").load(appsettings.getUrl("Group/GetOccupancyInfo?groupId=" + groupId));

            const color = (responseData.Success ? 'green' : 'red');
            $('#Users_Validation').text(responseData.Message);
            $('#Users_Validation').attr('style', 'color:' + color);
        }
    });
}

export function onSavedGroupUserOccupancy(groupId: number): void {
    tabUsersOccupancyLR(groupId);
    main.setHideDiv("UsersCB_Validation_Above", false);
    main.setHideDiv("UsersCB_Validation_Below", false);
}

/**
* Get Occupancy for the left and right.
* @param {number} groupId
*/
export function tabUsersOccupancyLR(groupId: number): void {
    $("#TableOccupancyLR").load(appsettings.getUrl("Group/GetOccupancyLR?groupId=" + groupId), function () {
        viewmode.applyViewMode("TableOccupancyLR");
    });
}

/**
* Get Occupancy information
* @param {number} groupId
*/
export function tabUsersOccupancyInfo(groupId: number): void {
    $("#TableOccupancyInfo").load(appsettings.getUrl("Group/GetOccupancyInfo?groupId=" + groupId), function () {
        viewmode.applyViewMode("TableOccupancyInfo");
    });
}


export function tabUsersOccupancyCBChanged(): void {
    main.setHideDiv("UsersCB_Validation_Above", true);
    main.setHideDiv("UsersCB_Validation_Below", true);
    $("#formGroupUserOccupancy_submitForm").removeAttr("disabled");
}

/**
* Initialize tab users 
* @param {Object} model
*/
export function tabUsersOccupancyInfoInitialize(): void {

    $("#formGroupUserOccupancy_submitForm").attr("disabled", "disabled");

    main.setHideDiv("UsersCB_Validation_Above", false);
    $("#UsersCB_Validation_Above").html(tabUsersGetDataChangedNotSavedYet()).text();

    main.setHideDiv("UsersCB_Validation_Below", false);
    $("#UsersCB_Validation_Below").html(tabUsersGetDataChangedNotSavedYet()).text();
}

//--- Vehicle ----------------------------------------------------------------------------------------------//

/**
* Initialize the vehicle tab
*/
export function tabVehicleInitialize(): void { }

/**
* Get the selected vehicles for the current selected group
* @param {number} groupId
*/
export function tabVehicleLV(groupId: number): void {
    $("#TabVehicleLV").load(appsettings.getUrl("Group/GetSelectedVehicles?groupId=" + groupId));
}

/**
* Vehicle input changed
*/
export function tabVehicleInputChanged(): void {
    const btnAdd = document.getElementById("GroupConfiguration_Vehicle_add-button");
    btnAdd.removeAttribute("disabled");
}

/**
* Vehicle input changed
*/
export function tabVehicleEnableDeleteButton(): void {
    const btnDelete = document.getElementById("GroupConfiguration_Vehicle_delete-button");
    btnDelete.removeAttribute("disabled");
}

/**
* Vehicle add clicked
* @param {number} groupId
*/
export function tabVehicleAddClicked(groupId: number): void {

    const inp = document.getElementById("TBVehicle") as HTMLInputElement;

    if (inp != undefined) {

        // Post Data
        $.ajax({
            type: "POST",
            url: appsettings.getUrl("Group/AddVehicleToGroup"),
            data: { label: inp.value, groupId: groupId },
            success: function (responseData) {
                // refresh list
                tabVehicleReloadListView(groupId);

                if (responseData != undefined && responseData != null) {

                    if (responseData.Succesfully == false) {
                        main.openActionsDialog(' ', responseData.Message,
                            [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    } else {
                        // clear add field
                        // document.getElementById("TBVehicle").value = "";
                        inp.value = "";

                        // disable Add button
                        document.getElementById("GroupConfiguration_Vehicle_add-button").setAttribute("disabled", "disabled");
                    }
                }
            }
        });
    }
}

/**
* Vehicle delete clicked event handler for the are you sure message
* @param {number} groupId
* @param {string} questionMessage
* @param {string} yesText
* @param {string} noText
*/
export function tabVehicleDeleteClicked(groupId: number, questionMessage: string, yesText: string, noText: string): void {
    main.openActionsDialog(' ', questionMessage,
        [{ text: yesText, action: function () { tabVehicleRemoveVehicle(groupId); main.closePopup(); } },
        { text: noText, action: function () { main.closePopup(); } }]);
}


/**
* Vehicle reload listview
* @param {number} groupId
*/
export function tabVehicleReloadListView(groupId: number): void {
    // Get Data
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("Group/LoadVehicles"),
        data: { groupId: groupId },
        success: function (responseData) {
            if (responseData != undefined) {
                const listView = $("#GroupConfiguration_Vehicle_CplSelected").data("kendoListBox");
                listView.dataSource.data(responseData.items);
            }
        }
    });
}

/**
* Vehicle remove vehicle from listview
* @param {number} groupId
*/
export function tabVehicleRemoveVehicle(groupId: number): void {

    let vehiclesArr: number[] = [];

    const listView = $("#GroupConfiguration_Vehicle_CplSelected").data("kendoListBox");

    if (listView != undefined) {

        const items = listView.select();
        const allitems = listView.items();

        for (let cnt = 0; cnt < items.length; cnt++) {
            const idx = allitems.index(items[cnt]);
            const dataItem = listView.dataSource.view()[idx];
            vehiclesArr[cnt] = parseInt(dataItem.Value);
        }
    }

    const list = vehiclesArr.slice();

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("Group/RemoveVehiclesFromGroup"),
        data: { list: kendo.stringify(list), groupId: groupId },
        success: function (responseData) {

            // refresh list
            tabVehicleReloadListView(groupId);

            if (responseData != undefined && responseData != null) {

                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                } else {

                    // disable delete button
                    document.getElementById("GroupConfiguration_Vehicle_delete-button").setAttribute("disabled", "disabled");
                }
            }

        }
    });
}


//--- Functions ----------------------------------------------------------------------------------------------------//

/**
* Tab: Functions, initialize with message 'not saved'
* @param {string} notsaved
*/
export function tabFunctionsInitialize(notsaved: string): void {
    _msg_notsaved = notsaved;

    $("#notSelectedSearchBox").on("input", function (e) {
        const listBox = $("#GroupConfiguration_Functions_CplNotSelected").data("kendoListBox");
        const searchString = $(this).val();

        listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
    });

    $("#selectedSearchBox").on("input", function (e) {
        const listBox = $("#GroupConfiguration_Functions_CplSelected").data("kendoListBox");
        const searchString = $(this).val();

        listBox.dataSource.filter({ field: "Text", operator: "contains", value: searchString });
    });
}

/**
* Tab: Functions, return message 'not saved'
* @return {string} notsaved
*/
export function tabFunctionsGetDataChangedNotSavedYet(): string {
    return _msg_notsaved;
}

/**
* Tab: Functions, move selected items from the right to the left
*/
export function tabFunctionsLeftClicked(): void {
    tabFunctionsEnableSaveButton();
    listbox.moveItems("GroupConfiguration_Functions_CplSelected", "GroupConfiguration_Functions_CplNotSelected", "#Functions_Validation", tabFunctionsGetDataChangedNotSavedYet());
}

/**
* Tab: Functions, move selected items from the left to the right
*/
export function tabFunctionsRightClicked(): void {
    tabFunctionsEnableSaveButton();
    listbox.moveItems("GroupConfiguration_Functions_CplNotSelected", "GroupConfiguration_Functions_CplSelected", "#Functions_Validation", tabFunctionsGetDataChangedNotSavedYet());
}

/**
* Tab: Functions, enable save button 
*/
export function tabFunctionsEnableSaveButton(): void {
    const btnSave = document.getElementById("saveButtonFunctions");
    btnSave.removeAttribute("disabled");
}

/**
* Tab: Functions, move selected items from the right to the left
* @param {Object} actionUrl
* @param {Object} number
*/
export function tabFunctionsSaveButtonClicked(actionUrl: string, groupId: number): void {
    tabFunctionsSave(actionUrl, groupId);
    tabFunctionsTraineeSave();
}

export function tabFunctionsSave(actionUrl: string, groupId: number): void {

    const listBox = $("#GroupConfiguration_Functions_CplSelected").data("kendoListBox");
    listBox.dataSource.filter({ field: "Text", operator: "contains", value: "" });

    const json = listBox.dataSource.view().toJSON();
    const list = json.slice();

    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        data: { list: kendo.stringify(list), groupId: groupId },
        success: function (responseData) {

            $('#Functions_Validation').text("");

            const color = (responseData.Success ? 'green' : 'red');
            $('#Functions_Validation').text(responseData.Message);
            $('#Functions_Validation').attr('style', 'color:' + color);

            $("#editTabstripGroup").data("kendoTabStrip").reload(".k-active");
        }
    });
}

/**
* Tab: Functions, Up click event
*/
export function tabFunctionsUpClicked(): void {
    const list = $("#GroupConfiguration_Functions_CplSelected").data("kendoListBox");
    tabFunctionsMoveUpDown(list, -1);
}

/**
* Tab: Functions, Down click event
*/
export function tabFunctionsDownClicked(): void {
    const list = $("#GroupConfiguration_Functions_CplSelected").data("kendoListBox");
    tabFunctionsMoveUpDown(list, 1);
}

/**
* Tab: Functions, sync 
* @param {Object} list
* @param {Object} indexModifier
*/
export function tabFunctionsMoveUpDown(list: any, indexModifier: number): void {
    const items = list.items();
    let selected = list.select();

    if (selected.length === 1) {
        selected = selected[0];
        const index = items.index(selected);
        const item = list.dataSource.view()[index];
        if (indexModifier === 1 && index < items.length - 1
            || indexModifier === -1 && index > 0) {
            list.dataSource.remove(item);
            list.dataSource.insert(index + indexModifier, item);
            list.select(list.items()[index + indexModifier]);
        }
    }

    $("#Functions_Validation").attr("style", "color:red");
    $("#Functions_Validation").html(tabFunctionsGetDataChangedNotSavedYet).text();

    tabFunctionsEnableSaveButton();
}

export function tabFunctionsOnSelect(groupId: number, e: ListBoxSelectEvent): void {
    main.setHideDivBootstrap("PTrainee", false);

    // check we are not in a "Data changed but not saved yet" situation
    if ($("#Functions_Validation").text() == '') {

        const element = e.sender.select();
        const selectedGroupServiceFunction = e.sender.dataItem(element[0]) as GroupServiceFunction;

        // Get Data
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("Group/GetFunctionTrainee"),
            data: { groupId: groupId, serviceFunctionId: selectedGroupServiceFunction.Value },
            success: function (responseData) {
                if (responseData != undefined) {
                    var cb = $("#CBTrainee")[0] as HTMLInputElement;
                    if (cb != null && cb != undefined) {
                        cb.checked = responseData.Trainee;
                        cb.name = responseData.GroupServiceFunctionID;
                    }

                    var cbLabel = $("#LTrainee")[0];
                    if (cbLabel != null && cbLabel != undefined) {
                        cbLabel.innerHTML = selectedGroupServiceFunction.Text;

                        //cbLabel.text(selectedGroupServiceFunction.Text);
                    }

                    main.setHideDivBootstrap("PTrainee", true);
                    tabFunctionsEnableSaveButton();
                }
            }
        });
    }
}

function tabFunctionsTraineeSave(): void {
    const cb = $("#CBTrainee")[0] as HTMLInputElement;
    if (!$("#PTrainee").hasClass('d-none') && cb != null && cb != undefined) {
        $.ajax({
            type: "POST",
            url: appsettings.getUrl("Group/UpdateFunctionTrainee"),
            data: { groupServiceFunctionId: cb.name, enable: cb.checked },
            success: function (responseData) {

                $('#Functions_Validation').text("");

                const color = (responseData.Succesfully ? 'green' : 'red');
                $('#Functions_Validation').text(responseData.Message);
                $('#Functions_Validation').attr('style', 'color:' + color);

                $("#editTabstripGroup").data("kendoTabStrip").reload(".k-active");
            }
        });
    }
}

//--- MINIMAL OCCUPANCY --------------------------------------------------------------------------------------------------------//

/**
* MinimalOccupation input changed
*/
export function tabMinimalOccupationInit(highText: string, lowText: string): void {

    MIN_OCCUPANCY_HIGH = highText;
    MIN_OCCUPANCY_LOW = lowText;

    const cbb = $("#CustomOccupancyMinMax").data("kendoDropDownList");
    if (cbb != null && cbb != undefined) {
        const hltxt = document.getElementById("DivHighLowText");

        switch (cbb.value()) {

            case '0':
                hltxt.innerHTML = "";
                cbb.value('');
                break;

            case '1':
                hltxt.innerHTML = MIN_OCCUPANCY_HIGH;
                break;

            case '2':
                hltxt.innerHTML = MIN_OCCUPANCY_LOW;
                break;
        }
    }

    if ($("#CustomOccupancy").data("kendoCheckBox").check()) {
        $(".CustomDispatch").show();
    } else {
        $(".CustomDispatch").hide();
    }
}

export function tabMinimalOccupationSetHighLowText(e: kendo.ui.DropDownListEvent): void {

    const hltxt = document.getElementById("DivHighLowText");

    switch (e.sender.value()) {

        case '':
            hltxt.innerHTML = "";
            break;

        case '1':
            hltxt.innerHTML = MIN_OCCUPANCY_HIGH;
            break;

        case '2':
            hltxt.innerHTML = MIN_OCCUPANCY_LOW;
            break;
    }
}


/**
* Minimal occupation delete clicked event handler for the "are you sure?" message
* @param {object} e
*/
export function tabMinimalOccupationCustomDispatch(e: kendo.ui.CheckBoxEvent): void {

    if (e.sender.check()) {
        $(".CustomDispatch").show();
    }
    else {
        $(".CustomDispatch").hide();
    }

}

/**
* Minimal occupation reload listview
* @param {number} groupId
*/
export function tabMinimalOccupationReloadListView(groupId: number): void {
    // Get Data
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("Group/LoadTextForMaxOccupancy"),
        data: { groupId: groupId },
        success: function (responseData) {
            if (responseData != undefined) {
                var listView = $("#GroupConfiguration_MinimalOccupation_CplSelected").data("kendoListBox");
                listView.dataSource.data(responseData.items);
            }
        }
    });
}

/**
* MinimalOccupation input changed
*/
export function tabMinimalOccupationEnableDeleteButton(): void {
    const btnDelete = document.getElementById("GroupConfiguration_MinimalOccupation_delete-button");
    btnDelete.removeAttribute("disabled");
}

/**
* MinimalOccupation input changed
*/
export function tabMinimalOccupationInputChanged(): void {
    const btnAdd = document.getElementById("GroupConfiguration_MinimalOccupation_add-button");
    btnAdd.removeAttribute("disabled");
}

/**
* Vehicle delete clicked event handler for the are you sure message
* @param {number} groupId
* @param {string} questionMessage
* @param {string} yesText
* @param {string} noText
*/
export function tabMinimalOccupationDeleteClicked(groupId: number, questionMessage: string, yesText: string, noText: string): void {
    main.openActionsDialog(' ', questionMessage,
        [{ text: yesText, action: function () { tabMinimalOccupationRemoveMinimalOccupation(groupId); main.closePopup(); } },
        { text: noText, action: function () { main.closePopup(); } }]);
}

/**
* MinimalOccupation add clicked
* @param {number} groupId
*/
export function tabMinimalOccupationAddClicked(groupId: number): void {

    const inp = document.getElementById("TBMinimalOccupation") as HTMLInputElement;

    if (inp != undefined) {

        // Post Data
        $.ajax({
            type: "POST",
            url: appsettings.getUrl("Group/AddTextForMaxOccupancy"),
            data: { Label: inp.value, GroupId: groupId },
            success: function (responseData) {
                // refresh list
                tabMinimalOccupationReloadListView(groupId);

                if (responseData != undefined && responseData != null) {

                    if (responseData.Succesfully == false) {
                        main.openActionsDialog(' ', responseData.Message,
                            [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    } else {
                        // clear add field
                        inp.value = "";

                        // disable Add button
                        document.getElementById("GroupConfiguration_MinimalOccupation_add-button").setAttribute("disabled", "disabled");
                    }
                }
            }
        });
    }
}

/**
* MinimalOccupation remove vehicle from listview
* @param {number} groupId
*/
export function tabMinimalOccupationRemoveMinimalOccupation(groupId: number): void {

    const vehiclesArr: number[] = [];

    const listView = $("#GroupConfiguration_MinimalOccupation_CplSelected").data("kendoListBox");

    if (listView != undefined) {

        const items = listView.select();
        const allitems = listView.items();

        for (let cnt = 0; cnt < items.length; cnt++) {
            const idx = allitems.index(items[cnt]);
            const dataItem = listView.dataSource.view()[idx];
            vehiclesArr[cnt] = parseInt(dataItem.Value);
        }
    }

    const list = vehiclesArr.slice();

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("Group/RemoveMinimalOccupationFromGroup"),
        data: { list: kendo.stringify(list), groupId: groupId },
        success: function (responseData) {

            // refresh list
            tabMinimalOccupationReloadListView(groupId);

            if (responseData != undefined && responseData != null) {

                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                } else {

                    // disable delete button
                    document.getElementById("GroupConfiguration_MinimalOccupation_delete-button").setAttribute("disabled", "disabled");
                }
            }

        }
    });
}


export function tabMinimalOccupationSaveSettings(): void {

    const post_data: PostData = {
        SelectedGroupId: Number($("#selectedGroupId").val()),
        VehicleSettings: new Array(),
        CustomOccupancy: $("#CustomOccupancy").data("kendoCheckBox").check(),
        IsMaxOccupationDesired: $("#IsMaxOccupationDesired").data("kendoCheckBox").check(),
        CustomOccupancyMinMax: Number($("#CustomOccupancyMinMax").data("kendoDropDownList").value())
    };

    // Get all the rows
    const vehicles = $(".vehicle-settings-row");

    // Loop through the rows
    for (let i = 0; i < vehicles.length; i++) {

        // Get the vehicle id 'hidden input'
        let vehicleId = $(vehicles[i]).find(".vehicleid").first().val();

        // Create vehicle object
        let vehicle: VehicleSetting = {
            Id: Number(vehicleId),
            Label: "vehicle" + i,
            IsAvailable: $("#vehicle_" + vehicleId + "_active").data("kendoCheckBox").check(),
            SettingsMinMax: new Array()
        };

        post_data.VehicleSettings.push(vehicle);

        // get all columns min max from the row 'vehicle'
        let columns = $(vehicles[i]).find(".funtion-settings-col");

        for (let j = 0; j < columns.length; j++) {
            // get identifiers to query the values from the kendo numeric textbox. hidden inputs
            let groupVehicleId = $(columns[j]).find(".groupVehicleId").first().val();
            let groupServiceFunctionId = $(columns[j]).find(".groupServiceFunctionId").first().val();

            // get the values
            let min_value = $("#" + groupVehicleId + "_" + groupServiceFunctionId + "_min").data("kendoNumericTextBox").value();
            let max_value = $("#" + groupVehicleId + "_" + groupServiceFunctionId + "_max").data("kendoNumericTextBox").value();

            // add new object
            let min_max_setting: MinMaxFunctionSetting = {
                GroupVehicleId: Number(groupVehicleId),
                GroupServiceFunctionId: Number(groupServiceFunctionId),
                Label: "vehicle" + i + "_function_" + j,
                Min: min_value,
                Max: max_value
            };
            post_data.VehicleSettings[i].SettingsMinMax.push(min_max_setting)
        }
    }

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("Group/Tab_MinOccupation_SaveSettings"),
        data: post_data,

        success: function (responseData) {
            // Show request result
            form.showServerResponse("dynamicform_group_min_occupancy", responseData, function () { });

            if (responseData.Succesfully) {
                setTimeout(function () { $("#editTabstripGroup").data("kendoTabStrip").reload(".k-active") }, 2500);
            }
        }
    });

}

//--- MINIMAL OCCUPANCY --------------------------------------------------------------------------------------------------------//


//--- CAPCODE --------------------------------------------------------------------------------------------------------//

/**
* Tab: Capcode initialize
*/
export function tabCapCodeInitialize(): void { }

/**
* Tab: Capcode, get selected capcodes 
* @param {number} groupId
*/
export function tabCapCodeLV(groupId: number): void {
    $("#TabCapCodeLV").load(appsettings.getUrl("Group/GetSelectedCapCodes?groupId=" + groupId));
}

/**
* Tab: Capcode, get selected Capcodes for vehicles 
* @param {number} groupId
*/
export function tabCapCodeVehicle(groupId: number): void {
    $("#TabCapCodeVehicle").load(appsettings.getUrl("Group/GetSelectedCapCodesVehicles?groupId=" + groupId));
}

/**
* Tab: Capcode, Add capcode -> enable button
*/
export function tabCapCodeInputChanged(): void {
    const btnAdd = document.getElementById("GroupConfiguration_CapCode_add-button");
    btnAdd.removeAttribute("disabled");
}

/**
* Tab: Capcode, Delete capcode -> enable button
*/
export function tabCapCodeEnableDeleteButton(): void {
    const btnDelete = document.getElementById("GroupConfiguration_CapCode_delete-button");
    btnDelete.removeAttribute("disabled");
}

/**
* Tab: Capcode, Add click 
* @param {number} groupId
*/
export function tabCapCodeAddClicked(groupId: number): void {

    const inp = document.getElementById("TBCapCode") as HTMLInputElement;

    if (inp != undefined) {

        // Post Data
        $.ajax({
            type: "POST",
            url: appsettings.getUrl("Group/AddCapCodeToGroup"),
            data: { capcode: inp.value, groupId: groupId },
            success: function (responseData) {

                // refresh active capcodes per vehicle 
                $("#TabCapCodeVehicle").load(appsettings.getUrl("Group/GetSelectedCapCodesVehicles?groupId=" + groupId));

                if (responseData != undefined && responseData != null) {

                    if (responseData.Succesfully == false) {
                        main.openActionsDialog(' ', responseData.Message,
                            [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    } else {

                        // clear add field
                        $("#TBCapCode").data("kendoNumericTextBox").value("");

                        // disable Add button
                        document.getElementById("GroupConfiguration_CapCode_add-button").setAttribute("disabled", "disabled");

                        // update listview
                        tabCapCodeReloadListView(groupId);
                    }
                }
            }
        });
    }
}

/**
* Tab: Capcode, reload listviews by groupid 
* @param {number} groupId
*/
export function tabCapCodeReloadListView(groupId: number): void {
    // Get Data
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("Group/LoadCapcodes"),
        data: { groupId: groupId },
        success: function (responseData) {
            if (responseData != undefined) {
                const listView = $("#GroupConfiguration_CapCode_CplSelected").data("kendoListBox");
                listView.dataSource.data(responseData.items);
            }
        }
    });
}

/**
* Tab: Capcode, Delete confirm 
* @param {number} groupId
* @param {string} questionMessage
* @param {string} yesText
* @param {string} noText
*/
export function tabCapCodeDeleteClicked(groupId: number, questionMessage: string, yesText: string, noText: string): void {

    main.openActionsDialog(' ', questionMessage,
        [{ text: yesText, action: function () { tabCapCodeRemoveVehicle(groupId); main.closePopup(); } },
        { text: noText, action: function () { main.closePopup(); } }]);
}

/**
* Tab: Capcode, Delete vehicle 
* @param {number} groupId 
*/
export function tabCapCodeRemoveVehicle(groupId: number): void {

    const capcodesArr: number[] = [];

    const listView = $("#GroupConfiguration_CapCode_CplSelected").data("kendoListBox");

    if (listView != undefined) {

        const items = listView.select();
        const allitems = listView.items();

        for (let cnt = 0; cnt < items.length; cnt++) {
            const idx = allitems.index(items[cnt]);
            const dataItem = listView.dataSource.view()[idx];
            capcodesArr[cnt] = parseInt(dataItem.Text);
        }
    }

    const list = capcodesArr.slice();

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("Group/RemoveCapCodesFromGroup"),
        data: { list: kendo.stringify(list), groupId: groupId },
        success: function (responseData) {

            tabCapCodeReloadListView(groupId);

            $("#TabCapCodeVehicle").load(appsettings.getUrl("Group/GetSelectedCapCodesVehicles?groupId=" + groupId));

            if (responseData != undefined && responseData != null) {

                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                } else {

                    // disable delete button
                    document.getElementById("GroupConfiguration_CapCode_delete-button").setAttribute("disabled", "disabled");
                }
            }

        }
    });
}

/**
* Tab Capcode: Visibility vehicle capcodes
* @param {boolean} visible 
*/
export function tabCapCodeSetVisibilityVehicleCapCodes(visible: boolean): void {

    const element = document.getElementById("divVehicleCapCodes");

    if (element !== undefined && element !== null) {

        if (visible) {
            element.style.display = "block";  // "inline";
        } else {
            element.style.display = "none";
        }
    }
}

/**
* Tab Capcode: get capcodes
* @param {number} groupId 
* @param {kendo.ui.DropDownListEvent} e 
*/
export function tabCapCodeGetCapCodesCbs(groupId: number, e: kendo.ui.DropDownListEvent): void {

    // Get
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("Group/GetCapCodesCbs"),
        data: { groupId: groupId, groupVehicleId: e.sender.value() },
        success: function (responseData) {
            $("#checkboxgroup").data("kendoCheckBoxGroup").value(responseData.capcodeArr);
        }
    });

}

/**
* Tab Capcode: save checkbox groups
* @param {number} groupId 
* @param {number} vehicleId 
* @param {kendo.ui.CheckBoxGroupEvent} e 
*/
export function tabCapCodeSaveCheckBoxGroup(groupId: number, vehicleId: number, e: kendo.ui.CheckBoxGroupEvent): void {

    const vehicles: number[] = [];

    const checkboxes = $("#checkboxgroup").data("kendoCheckBoxGroup").value();

    for (let i = 0; i < checkboxes.length; i++) {
        vehicles[i] = parseInt(checkboxes[i]);
    }

    const list = vehicles.slice();

    // Post Data
    $.ajax({
        type: "POST",
        url: appsettings.getUrl("Group/SaveCheckBoxGroupValues"),
        data: { list: kendo.stringify(list), groupId: groupId, vehicleId: vehicleId },
        success: function (responseData: responseModel | undefined | null) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }
        }
    });
}


//--- TAB_PATTERN -----------------------------------------------------------------------------

export function tabPatternInitialize(groupId: number, labelYes: string, labelNo: string, labelDelete: string): void {

    // Add
    $(document)
        .off("click.overviewAddPattern", "#GroupConfigurationPatternGrid .k-grid-add")
        .on("click.overviewAddPattern", "#GroupConfigurationPatternGrid .k-grid-add", function (e: JQuery.Event): void {

        // Prevent default behaviour
        e.preventDefault();

        // Load create form into the current module div
        navigation.navigateToSpecificUrl("Group/AddPattern?groupId=" + groupId);
    });
    grid.loadGridOptions("GroupConfigurationPatternGrid");
    LABEL_YES = labelYes;
    LABEL_NO = labelNo;
    LABEL_DELETE = labelDelete;
}

export function tabPatternShowItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as GroupPattern;

    // Show mode form 
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Group/ShowPattern?patternId=" + dataItem.PatternID + "&breadcrumbLabel=" + encodeURIComponent(dataItem.Label));
}

export function tabPatternEditItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as GroupPattern;

    // Edit mode form 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Group/EditPattern?patternId=" + dataItem.PatternID + "&breadcrumbLabel=" + encodeURIComponent(dataItem.Label));
}

export function tabPatternDeleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as GroupPattern;

    main.openActionsDialog(' ', LABEL_DELETE + ' ' + dataItem.Label + ' ?',
        [{ text: LABEL_YES, action: function () { tabPatternDeletePattern(dataItem.PatternID, dataItem.GroupID); main.closePopup(); } },
        { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
}

export function tabPatternDeletePattern(patternId: number, groupId: number): void {
    $.ajax({
        type: "GET",
        url: appsettings.getUrl("Group/DeletePattern?patternId=" + patternId),
        success: function (responseData: responseModel | undefined | null) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            navigation.navigateToSpecificUrl("Group/Tab_Pattern?groupId=" + groupId);
        }
    });
}


//--- TAB_CREW ----------------------------------------------------------------

export function tabCrewInitialize(groupId: number, labelYes: string, labelNo: string, labelDelete: string): void {

    // Add
    $(document)        
        .off("click.overviewAddCrew", "#GroupConfigurationCrewGrid .k-grid-add")
        .on("click.overviewAddCrew", "#GroupConfigurationCrewGrid .k-grid-add", function (e: JQuery.Event): void {

        // Prevent default behaviour
        e.preventDefault();

        // Load create form into the current module div
        navigation.navigateToSpecificUrl("Group/AddCrewname?groupId=" + groupId);
    });
    grid.loadGridOptions("GroupConfigurationCrewGrid");
    LABEL_YES = labelYes;
    LABEL_NO = labelNo;
    LABEL_DELETE = labelDelete;
}


export function tabCrewShowItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as GroupCrew;

    // Show mode form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Group/Show_Crewname?ploegnaamId=" + dataItem.PloegnaamID + "&breadcrumbLabel=" + encodeURIComponent(dataItem.Label));
}


export function tabCrewEditItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as GroupCrew;

    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Group/Edit_Crewname?ploegnaamId=" + dataItem.PloegnaamID + "&breadcrumbLabel=" + encodeURIComponent(dataItem.Label));
}


export function tabCrewDeleteClicked(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    e.preventDefault();

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as GroupCrew;

    main.openActionsDialog(' ', LABEL_DELETE + ' ' + dataItem.Label + ' ?',
        [{ text: LABEL_YES, action: function () { tabCrewDeleteItem(dataItem.PloegnaamID, dataItem.GroupID); main.closePopup(); } },
        { text: LABEL_NO, action: function () { main.closePopup(); }, primary: true }]);
}


export function tabCrewDeleteItem(ploegnaamId: number, groupId: number): void {

    $.ajax({
        type: "GET",
        url: appsettings.getUrl("Group/DeleteCrewname?ploegnaamId=" + ploegnaamId),
        success: function (responseData: responseModel | undefined | null) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            navigation.navigateToSpecificUrl("Group/Tab_Crew?groupId=" + groupId);
        }
    });
}
